/* @flow */

import * as React from 'react';
import PropTypes from 'prop-types';

export const TopBarContentProviderContextPropType = PropTypes.shape({
  renderTopBarContent: PropTypes.func,
  renderUnderTopBarContent: PropTypes.func,
});

export type TopBarContentProviderContext = {
  ui_tbc: {
    renderTopBarContent?: React.Node,
  },
};

type TopBarContentProviderProps = {
  renderTopBarContent?: null | (() => React.Node),
  children: React.Node,
};

export default class TopBarContentProvider extends React.Component<TopBarContentProviderProps> {
  static childContextTypes = {
    ui_tbc: TopBarContentProviderContextPropType,
  };

  getChildContext(): TopBarContentProviderContext {
    return {
      ui_tbc: {
        renderTopBarContent: this.props.renderTopBarContent,
      },
    };
  }

  render() {
    return this.props.children;
  }
}
